import { render, staticRenderFns } from "./index.vue?vue&type=template&id=42d1e247&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=42d1e247&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d1e247",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42d1e247')) {
      api.createRecord('42d1e247', component.options)
    } else {
      api.reload('42d1e247', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=42d1e247&scoped=true", function () {
      api.rerender('42d1e247', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/senate/eliminate-class/index.vue"
export default component.exports